import { createFileRoute } from '@tanstack/react-router';

import { FamilyLinkage } from '../../components/FamilyLinkage/FamilyLinkage';

export const Route = createFileRoute('/_auth/family-linkage')({
  component: FamilyLinkage,
});
